import * as types from "../constants/actionTypes";
import initialState from "./initialState";

export const regionResultsReducer = (
  state = initialState.regionResults,
  action
) => {
  switch (action.type) {
    case types.GET_REGION_RESULTS_FAIL: {
      return initialState.regionResults;
    }
    case types.GET_REGION_RESULTS_SUCCESS: {
      return action.payload;
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/regionResultsReducer.js